<div ng-show="!InformativoCtrl.isLoadingDependencies"><vfwc-informativo id="informativo-box"></vfwc-informativo></div>